module.exports = __webpack_public_path__ + "static/img/5.e2d8881.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/huawei/5.png
// module id = Ld1S
// module chunks = 0